const productList = {
  state: {
    /*产品中心
  * Img 图片链接 只需要修改require里面的路径（图片存放于assets/img/product文件夹中）
  * Title 产品标题
  * */
    productList: [{
      "Img": require('../../assets/img/product/AE箱.jpg'),
      "Title": "AE箱",
    }, {
      "Img": require('../../assets/img/product/BES不锈钢.jpg'),
      "Title": "BES不锈钢",
    }, {
      "Img": require('../../assets/img/product/BKL接线箱.jpg'),
      "Title": "BKL接线箱",
    }, {
      "Img": require('../../assets/img/product/ES柜.jpg'),
      "Title": "ES柜",
    }, {
      "Img": require('../../assets/img/product/GGD配电柜.jpg'),
      "Title": "GGD配电柜",
    }, {
      "Img": require('../../assets/img/product/GGD配电柜2.jpg'),
      "Title": "GGD配电柜2",
    }, {
      "Img": require('../../assets/img/product/KL接线箱.jpg'),
      "Title": "KL接线箱",
    }, {
      "Img": require('../../assets/img/product/L型悬臂箱.jpg'),
      "Title": "L型悬臂箱",
    }, {
      "Img": require('../../assets/img/product/PC电脑柜.jpg'),
      "Title": "PC电脑柜",
    }, {
      "Img": require('../../assets/img/product/PS九折柜.jpg'),
      "Title": "PS九折柜",
    }, {
      "Img": require('../../assets/img/product/U型悬臂箱.jpg'),
      "Title": "U型悬臂箱",
    }, {
      "Img": require('../../assets/img/product/三段式操作台.jpg'),
      "Title": "三段式操作台",
    }, {
      "Img": require('../../assets/img/product/支撑型悬臂箱.jpg'),
      "Title": "支撑型悬臂箱",
    }, {
      "Img": require('../../assets/img/product/斜面操作台.jpg'),
      "Title": "斜面操作台",
    }, {
      "Img": require('../../assets/img/product/斜面操作台1.jpg'),
      "Title": "斜面操作台1",
    }, {
      "Img": require('../../assets/img/product/温控系列.jpg'),
      "Title": "温控系列",
    }, {
      "Img": require('../../assets/img/product/附件.jpg'),
      "Title": "附件",
    }
]
  }
}

export default productList